export default __webpack_public_path__ + "static/media/header-mdu.3ab8d916.jpg";